export { default as ErrorAggregator } from './errorAggregator'
